import { ProjectStatusType } from 'src/types'

export const useProjectStatus = () => {
  const getHasArchived = (projectStatuses: ProjectStatusType[]) => {
    return projectStatuses.some(status => status.name === 'archived')
  }

  return {
    getHasArchived,
  }
}
